module.exports = __webpack_public_path__ + "static/media/16_tn.9b05028c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/16_tn.jpg
// module id = 446
// module chunks = 0